"use client";
import { MobileDrawer } from "@cmp-src/mobile/MobileDrawer/MobileDrawer";
import {
  delegatedPermissionPartials,
  getMSTwoWayUrl
} from "@gettactic/helpers";
import { useBreakpoint } from "@gettactic/helpers/src/hooks/useBreakpoint";
import { useAuthenticated } from "@gettactic/hooks";
import React, { useCallback } from "react";
import {
  DelegatedPermissionRequest,
  DelegatedPermissionRequestContent
} from "@/features/reserve/components/Reserve/DelegatedPermissionRequest";

const integrationsUrl = process.env.NEXT_PUBLIC_TACTIC_INTEGRATIONS_URL;

export interface RSVPDelegatedPermissionRequestProps {
  isOpen: boolean;
  onClose: () => void;
}

/** Shown when an RSVP is rejected because the user hasn't granted Outlook delegated access. */
export const RSVPDelegatedPermissionRequest: React.FC<
  RSVPDelegatedPermissionRequestProps
> = ({ isOpen, onClose }) => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();
  const { isBreakpoint } = useBreakpoint();
  const isMd = isBreakpoint("md");
  const orgSlug = authenticatedUser?.organization?.slug;
  // Left empty without both parts, which keeps the Connect Outlook button disabled
  const msAuthUrl =
    integrationsUrl && orgSlug ? getMSTwoWayUrl(integrationsUrl, orgSlug) : "";

  const handleConnectOutlook = useCallback(() => {
    window.open(msAuthUrl);
  }, [msAuthUrl]);

  // On phones the RSVP controls sit inside a MobileDrawer (z-modal), which
  // covers the desktop Modal (z-drawer), so the prompt opens as a drawer on top
  if (!isMd) {
    return (
      <MobileDrawer
        isOpen={isOpen}
        onOpenChange={(open) => {
          if (!open) onClose();
        }}
        ariaLabel={delegatedPermissionPartials.title}
      >
        <h2 className="px-6 pt-2 text-center font-semibold text-content-strong text-view-title">
          {delegatedPermissionPartials.title}
        </h2>
        <DelegatedPermissionRequestContent
          msAuthUrl={msAuthUrl}
          handleConnectOutlook={handleConnectOutlook}
          description={delegatedPermissionPartials.rsvpDescription}
        />
      </MobileDrawer>
    );
  }

  return (
    <DelegatedPermissionRequest
      isOpen={isOpen}
      onClose={onClose}
      msAuthUrl={msAuthUrl}
      description={delegatedPermissionPartials.rsvpDescription}
    />
  );
};
